import listItem from './listItem'
import { Content } from './types'

const list: Content = {
    type: 'list',
    name: 'Lijst',
    children: [listItem],
}

export default list
